var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36676 9.03333C8.75667 9.03333 9.88343 7.90658 9.88343 6.51666C9.88343 5.12675 8.75667 4 7.36676 4C5.97684 4 4.8501 5.12675 4.8501 6.51666C4.8501 7.90658 5.97684 9.03333 7.36676 9.03333Z",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29175 16V14.5667C2.29175 12.9 3.64174 11.55 5.30841 11.55H9.82508C11.4917 11.55 12.8418 12.9 12.8418 14.5667V16",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6501 9.74999C14.681 9.74999 15.5167 8.91426 15.5167 7.88333C15.5167 6.8524 14.681 6.01666 13.6501 6.01666C12.6191 6.01666 11.7834 6.8524 11.7834 7.88333C11.7834 8.91426 12.6191 9.74999 13.6501 9.74999Z",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1834 11.6167H15.4667C16.7001 11.6167 17.7001 12.6167 17.7001 13.85V14.9167",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsers);
export default __webpack_public_path__ + "static/media/ic_users.419989fc3b1bf1d149c520a3170289b1.svg";
export { ForwardRef as ReactComponent };